import { ApplicationConfig, provideZoneChangeDetection } from '@angular/core';
import { provideRouter } from '@angular/router';

import { routes } from './app.routes';
import {
  provideClientHydration,
  withEventReplay,
  withHttpTransferCacheOptions,
} from '@angular/platform-browser';
import { HttpService } from './services/http.service';
import { HeaderService } from './services/header.service';
import { NotificationService } from './services/notification.service';
import { ConfirmModalService } from './services/confirm-modal.service';
import { provideHttpClient, withFetch } from '@angular/common/http';
import { SportFilterService } from './services/sport-filter.service';
import { ClubService } from './services/club.service';
import { provideAnimations } from '@angular/platform-browser/animations';
import { MatchService } from './services/match.service';
import { TournamentService } from './services/tournament.service';
import { EventService } from './services/event.service';
import { MatchSessionService } from './services/match-session.service';
import { NavigationService } from './services/navigation.service';

export const appConfig: ApplicationConfig = {
  providers: [
    provideAnimations(),
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes),
    provideClientHydration(
      withEventReplay(),
      withHttpTransferCacheOptions({
        includePostRequests: true,
      })
    ),
    provideHttpClient(withFetch()),
    HttpService,
    HeaderService,
    NotificationService,
    ConfirmModalService,
    SportFilterService,
    ClubService,
    MatchService,
    TournamentService,
    EventService,
    MatchSessionService,
    NavigationService
  ],
};
